"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var flash_1 = require("../../flash");
var create_offer_button_1 = require("@reverbdotcom/commons/dist/offers/create_offer_button");
var bind_1 = require("../../bind");
// This is a wrapper to export to core so that we can pass the offer flash callback function.
// Once we update the item page to no longer be a Frankenstein between core/FE then we can
// rip this out. :sigh:
var OfferButtonWithFlash = /** @class */ (function (_super) {
    tslib_1.__extends(OfferButtonWithFlash, _super);
    function OfferButtonWithFlash() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OfferButtonWithFlash.prototype.onOfferSuccess = function (message) {
        flash_1.flashSuccess(message);
    };
    OfferButtonWithFlash.prototype.render = function () {
        return (React.createElement(create_offer_button_1.default, { listingId: this.props.listingId, onOfferSuccess: this.onOfferSuccess, listingThumbnail: this.props.listingThumbnail }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], OfferButtonWithFlash.prototype, "onOfferSuccess", null);
    return OfferButtonWithFlash;
}(React.Component));
exports.default = OfferButtonWithFlash;
//# sourceMappingURL=offer_button_with_flash.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/offer_button_with_flash.js
// module id = mBjb
// module chunks = 20 21